import dynamicMessages from '../locales/dynamicMessages'
import { action, computed, observable, reaction, makeObservable } from 'mobx'
import { SESSION_API } from '@voicekey/api/session/session'
import { getURL, URL_TYPES } from '@voicekey/api/http'

export const MODULES = {
  MEDIASTORAGE: 'MEDIA_STORAGE'
}

export class PrivilegeStore {
  constructor (rootStore) {
    makeObservable(this, {
      _privileges: observable,
      getPrivileges: action
    })

    this.rootStore = rootStore

    reaction(
      () => this.rootStore.sessionStore.sessionId,
      () => {
        this.privileges = null
        sessionStorage.removeItem('privileges')
      }
    )
  }

  _privileges = null

  get privileges () {
    return this._privileges
  }

  set privileges (value) {
    this._privileges = value
  }

  async getPrivileges (moduleName) {
    const privileges = JSON.parse(sessionStorage.getItem('privileges'))
    if (privileges) {
      this.privileges = privileges
    } else {
      try {
        const response = await SESSION_API.getPrivileges(
          getURL(URL_TYPES.SESSION),
          { names: [moduleName] },
          this.rootStore.sessionStore.sessionId
        )
        if (!this.privileges) {
          this.privileges = {}
        }
        this.privileges[moduleName] = response.data[moduleName]
        sessionStorage.setItem('privileges', JSON.stringify(this.privileges))
      } catch (e) {
        this.rootStore.messagesStore.setMessage({
          ...dynamicMessages.unable_get_privileges,
          info: e
        })
      }
    }
  }

  isPrivilege (privilege, moduleName) {
    return computed(() => (
      this.privileges &&
      this.privileges[moduleName] &&
      this.privileges[moduleName].includes(privilege)
    ))
  }

  availableLinks (links, moduleName) {
    return computed(() => {
      return Object.entries(links).reduce((accumulator, [tabName, link]) => {
        if (!link.privilegeName || this.isPrivilege(link.privilegeName, moduleName).get()) {
          accumulator[tabName] = link
        }
        return accumulator
      }, {})
    })
  }
}
